/*
 * @Author: gongzhichao 18311120024@163.com
 * @Date: 2023-05-25 19:05:44
 * @LastEditors: gongzhichao 18311120024@163.com
 * @LastEditTime: 2024-05-22 12:08:48
 * @FilePath: \jyrg-web\src\api\webSiteThree.js
 * @Description: 测试服接口文件
 */
import request from "@/request/requestThree";

const urls = {
  getAllNews: "/api/publicsrc/searchAllNews",
  searchNewsById: "/api/publicsrc/searchNewsById",
  searchHeadTitles: "/api/publicsrc/searchHeadTitles",
  searchGameData: "/api/publicsrc/searchGameData",
  searchLatestNews: "/api/publicsrc/searchLatestNews",
  getActivityImg: "/api/publicsrc/searchThreeNews",
  searchOthers: "/api/publicsrc/searchOthersOne",
  searchFooter: "/api/publicsrc/searchFooterOne",
};

const webSite = {
  getAllNews: (newsType) => {
    return request({
      url: urls.getAllNews,
      method: "get",
      params: {
        newsType: newsType,
      },
    });
  },

  searchNewsById: (params) => {
    return request({ url: urls.searchNewsById, method: "post", data: { ...params } });
  },

  searchGameData: (gameDataType) => {
    return request({
      url: urls.searchGameData,
      method: "get",
      params: {
        gameDataType: gameDataType,
      },
    });
  },

  searchLatestNews: (newsType) => {
    return request({
      url: urls.searchLatestNews,
      method: "get",
      params: {
        newsType: newsType,
      },
    });
  },

  getActivityImg: () => {
    return request({ url: urls.getActivityImg, method: "get" });
  },

  searchOthers: (params) => {
    return request({ url: urls.searchOthers, method: "post", data: { ...params } });
  },

  searchFooter: (params) => {
    return request({ url: urls.searchFooter, method: "post", data: { ...params } });
  },

  searchHeadTitles: () => {
    return request({ url: urls.searchHeadTitles, method: "get" });
  },
};

export default webSite;
